import React from 'react';
import {Header,Item, Label,  Breadcrumb, Table, Transition, Icon, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Popup} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';


const ResultadoExamen=({ id, ajaxCallInProgress, errors=[], strings, onSave,onChange,datos,inscripcionCombo, examenCombo})=>{

    return (
        <Container>
        
            <Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                                            
                            <Form.Field  required  error={errors.idUsuario}>            
                              <label  >{strings?strings["idUsuario"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idUsuario"]:""} 
                                    name="idUsuario"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idUsuario}
                                    options={inscripcionCombo}/>
                            </Form.Field>
        
                            <Form.Field  required  error={errors.idFormulario}>            
                              <label  >{strings?strings["idFormulario"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idFormulario"]:""} 
                                    name="idFormulario"
									 fluid 
                                    search 
                                    selection
                                    onChange={onChange}
                                    value={datos.idFormulario}
                                    options={examenCombo}/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.numberOfQuestions}>            
                              <label  >{strings?strings["numberOfQuestions"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["numberOfQuestions"]:""} 
                                    name="numberOfQuestions"
                                    onChange={onChange}
                                    value={datos.numberOfQuestions}
                                    icon='edit'/>
                            </Form.Field>
                                            
                            <Form.Field  required  error={errors.numberOfCorrectAnswers}>            
                              <label  >{strings?strings["numberOfCorrectAnswers"]:""}</label>
                              <Input 
                                    placeholder={strings?strings["numberOfCorrectAnswers"]:""} 
                                    name="numberOfCorrectAnswers"
                                    onChange={onChange}
                                    value={datos.numberOfCorrectAnswers}
                                    icon='edit'/>
                            </Form.Field>
                                                                                         
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/resultadoexamens">
                                    <Button  
										>{strings?strings["regresar"]:""}</Button>
                                </Link>
                                <Button.Or text=" "></Button.Or>
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                           <br/>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        
         </Container>
	);
};



export default ResultadoExamen;
    